import { createRoot } from 'react-dom/client'
import 'react-datepicker/dist/react-datepicker.css'

import { registerLocale } from 'react-datepicker'
import { ptBR } from 'date-fns/locale/pt-BR'

registerLocale('pt-BR', ptBR)

import App from './App.tsx'

createRoot(document.getElementById('root')!).render(<App />)
